import "./stepper.css";

export default function Stepper({ steps, activeStep, onStepClick }) {
  return (
    <div className="stepper">
      {steps.map((step, index) => (
        <div
          key={index}
          className={`step ${index === activeStep ? "active" : ""}
            ${index < activeStep ? "completed" : ""}`}
          onClick={() => onStepClick(index)}
        >
          <div className="circle">
            {index + 1}
          </div>

          <span>{step.label}</span>

          {index !== steps.length - 1 && (
            <div className="line"></div>
          )}
        </div>
      ))}
    </div>
  );
}